import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import defaultSettings from "@/settings";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/privacy", '/register']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title, store.getters.opeInfo.title);

  // determine whether the user has logged in
  // 来自C端的引流登录/注册
  if(to.query.name == 'cmeetyou'){
      let str = JSON.stringify(to.query);
      localStorage.setItem('cmeetyou',str);    
  }
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else if (to.path === "/privacy") {
      next();
    } else {
      const hasGetUserInfo = store.getters.name;
      if (hasGetUserInfo) {
        next();
      } else {
        try {
          // 用户信息
          if (localStorage.getItem("userInfo")) {
            let userInfo = JSON.parse(localStorage.getItem("userInfo"));
            if (userInfo) {
              store.dispatch("user/amendInfo", userInfo);
            }
          }
          // 左侧菜单
          if (defaultSettings.stateMenu) {
            // 左侧动态菜单
            let localmenus = localStorage.getItem("menus")
              ? JSON.parse(localStorage.getItem("menus"))
              : [];
            if (localmenus && localmenus.length > 0) {
              // 缓存中不存在左侧菜单
              if (store.getters.menus.length < 1) {
                global.antRouter = [];
                next();
              }
              global.antRouter = localmenus; // 3.将路由数据传递给全局变量，做侧边栏菜单渲染工作
              next({ ...to, replace: true });
            } else {
              await store.dispatch("user/getAntRouter"); // 请求获取路由信息
              if (store.getters.menus.length < 1) {
                global.antRouter = [];
                next();
              }
              const menus = filterAsyncRouter(store.getters.menus); // 1.过滤路由
              global.antRouter = menus; // 3.将路由数据传递给全局变量，做侧边栏菜单渲染工作
              // 把菜单存入缓存
              localStorage.setItem("menus", JSON.stringify(menus));
              next({ ...to, replace: true });
            }
          } else {
            next();
          }
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});

// // 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.name && route.name !== "") {
      route.meta = {
        title: route.name,
        icon: route.icon && route.icon !== "" ? route.icon : "",
        pitchIcon:
          route.pitch_icon && route.pitch_icon !== "" ? route.pitch_icon : "",
        name: route.remark
      };
    }
    route.hidden = route.is_hide == 1 ? true : false;
    if (route.node && route.node.length > 0) {
      route.children = route.node;
      route.children = filterAsyncRouter(route.children);
      delete route.node;
    }
    if (route.children && route.children.length == 1) {
      route.alwaysShow = true;
    }
    return true;
  });

  return accessedRouters;
}
